export const STADIA_MAPS_API_KEY = '8f526c3f-4318-4366-a986-3b5a21fba6e8';

export const PRODUCTION_URL = 'https://fossi-livorno.mezzoforte.design/';